import { createWS, send, onMessage } from '@/ws'
import { useMainStore } from '@/store'

// let subscribed = false

export function useIndexWS(sendData, onData) {
    const store = useMainStore()

    const url =
        import.meta.env.VITE_WS_BASE_URL +
        '?wstoken=' +
        store.loginInfo.wstoken

    createWS(url)

    // if (!subscribed) {
        send(sendData)
        // subscribed = true
    // }

    const off = onMessage(msg => {
        if (msg.status === 1) {
            onData(msg.info)
        }
    })

    return off
}
